var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{'button button__medium mb-2': !_vm.completed, edited: _vm.completed},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.completed)?[_vm._v("\n    Edit "),_c('PencilIcon')]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }